const translations = {
  page_title: 'Notifications',

  // Table columns
  title: 'Title',
  content: 'Content',
  type: 'Type',
  namespace: 'Namespace',
  created_at: 'Created At',
  role: 'Role',
  account: 'Account',
  all_users: 'All users',

  // Results
  no_notifications_to_show: 'No notifications to show',
  description: 'Push notifications created to be sent to mobile app users.',
  no_notifications_description: 'There are no notifications to display.',
  select_account_to_view: 'Select an account to view notifications',
  select_account_description: 'Choose one or more accounts to load their notifications.',

  // Actions
  create_notification: 'Send a new notification',
  create_notification_title: 'Send a new notification',
  view_notification_title: 'Notification details',
  title_placeholder: 'Enter notification title',
  title_en: 'Title (English)',
  title_es: 'Title (Spanish)',
  title_placeholder_en: 'Enter title in English',
  title_placeholder_es: 'Enter title in Spanish',
  content_placeholder: 'Enter notification content',
  content_en: 'Content (English)',
  content_es: 'Content (Spanish)',
  content_placeholder_en: 'Enter content in English',
  content_placeholder_es: 'Enter content in Spanish',
  role_placeholder: 'Select roles',
  notification_created_success: 'Notification created successfully',

  // Filters
  search_placeholder: 'Search by title or content',
  select_role: 'Select role',
  select_type: 'Select type',
  select_account: 'Select account',
  select_language: 'Select language',
  language_en: 'English',
  language_es: 'Spanish',
  type_generic: 'Generic',
  type_vehicle_created: 'Vehicle created',
};

export default translations;
